import { Directive, effect, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { InputSelectionStyles, applyDatepickerCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-datepicker',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxDatepickerStyleDirective {
  componentStyle = input<{
    style: InputSelectionStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyDatepickerCustomStyles(
        this.componentStyle().style,
        theme(),
        fonts()
      )
      this.styleClassName.set(className)
    })
  }
}
